import { useState, useEffect } from 'react';
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { contructParamsForLDBImpersonating } from 'legacy-src/components/impersonating/utils';
import { getSharedResources } from 'legacy-src/actions/sharedResources';
import { setSecureAssignmentIds } from 'chameleon/legacy/src/actions/secureAssignmentIds';
import { wizardVideo } from './queries';

const useFetchTodos = ({
  dispatch,
  client,
  subjectId,
  classIds,
  educationPeriod,
  isImpersonating,
}) => {
  const [state, setState] = useState({
    todos: [],
    loading: true,
    hasPeAssignments: false,
    sharedResources: [],
  });

  const actionDispatch = bindActionCreators(
    {
      getSharedResources,
      setSecureAssignmentIds,
    },
    dispatch,
  );

  let apiParams = {
    is_chameleon: 1,
  };
  if (isImpersonating) {
    // pass impersonating details so we can add it to the ldb secure url for secure assignments
    apiParams = { ...apiParams, ...contructParamsForLDBImpersonating() };
  }

  useEffect(() => {
    if (!educationPeriod || !classIds.length) {
      return;
    }

    const getTodos = async () => {
      try {
        // fetch todos
        const response = await axios({
          method: 'get',
          url: `${FYM_BACKEND_URL}/todos/${subjectId}/student/`,
          params: apiParams,
          headers: {
            'Content-Type': 'application/json',
          },
        });

        // fetch shared resources - updates the redux
        actionDispatch.getSharedResources({
          client,
          subjectId,
          classIds,
          educationPeriod,
        });

        const todosList = response.data;
        const hasPeAssignments = !!todosList.some(
          ({ is_cb_practice_quiz, headline }) =>
            is_cb_practice_quiz && headline !== 'GET FEEDBACK',
        );
        const fetchedTodos = todosList.filter(
          ({ is_cb_practice_quiz, headline, is_spp }) =>
            !(is_cb_practice_quiz && headline !== 'GET FEEDBACK') &&
            !(headline === 'VIEW RESULTS' && is_spp),
        );

        const secureAssignmentIds = fetchedTodos
          .filter((assignment) => assignment.is_secure)
          .reduce((acc, cur) => {
            acc[cur.id] = cur.secure_link;
            return acc;
          }, {});

        actionDispatch.setSecureAssignmentIds(secureAssignmentIds);
        setState({
          todos: fetchedTodos,
          hasPeAssignments,
          loading: false,
        });
      } catch (error) {
        setState({
          ...state,
          loading: false,
        });
      }
    };

    getTodos();
  }, [subjectId, educationPeriod, classIds]);

  return {
    ...state,
  };
};

const useGetWizardVideoTodos = () => {
  const [video, setVideo] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const getVideos = async () => {
      const data = {
        query: wizardVideo,
      };
      const response = await axios({
        method: 'post',
        url: `${FYM_WIZARDS_BACKEND_URL}/graphql/`,
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      });

      const videoTodo = response.data.data.video;
      setVideo({ ...videoTodo });
      setIsLoading(false);
    };

    getVideos();
  }, []);

  return {
    video,
    isLoading,
  };
};
export { useFetchTodos, useGetWizardVideoTodos };
